import React from "react"
import styled from "styled-components"
import GridContainer from "@/components/common/GridContainer"
import { getCssSizeValue } from "@/utils/utils"
import CommonButton from "@/components/common/Buttons/Button"
import { BREAKPOINTS } from "@/styles/themeSettings"
import WhiteBlock from "@/components/Banners/KRS/WhiteBlock"
import CopyToolTip from "@/components/ToolTip/Variants/CopyToolTip"
import { TOOLTIP_POSITION } from "@/components/ToolTip/BaseToolTip"
import { getLinkData } from "@/components/common/Links/utils"
import { useIsMobile } from "@/hooks/useDevice"

const Wrapper = styled(GridContainer)`
	position: relative;
	width: 100%;
	background-color: ${({ theme }) => theme.colors.richBlue};
	padding: ${getCssSizeValue(72, BREAKPOINTS.DESKTOP)} 0 ${getCssSizeValue(23, BREAKPOINTS.DESKTOP)};
`

const CopyWrapper = styled.div`
	//grid-column: 15/17;
	--start: calc(var(--grid-count) - 1);
	--end: calc(var(--grid-count) + 1);
	grid-column: var(--start, 15) / var(--end, 17);
	align-self: end;
	justify-self: end;
	text-transform: uppercase;
`

const BannerKRS = ({ data }) => {
	const krsLinkData = data?.krsLink || ""
	const krsRedButtonText = data?.krsRedButtonText || ""
	const { url } = getLinkData(krsLinkData)
	const isMobile = useIsMobile()
	// const krs = useMemo(() =>
	// 	transfers.transferCategories
	// 		.map((cat) => cat.items)
	// 		.flat()
	// 		.find((item) => item.type === TRANSFER_TYPES.KRS)
	// ,[transfers])

	return (
		<Wrapper className={`no-margin padding`}>
			<WhiteBlock
				krs={data.krsValue}
				title={data.krsTitle}
				helper1={data.krsHelperText1}
				helper2={data.krsHelperText2}
				className="col-mobile-5 col-tablet-5 col-desktop-11"
				url={url}
			/>
			<CopyWrapper>
				<CopyToolTip position={isMobile ? TOOLTIP_POSITION.LEFT : TOOLTIP_POSITION.TOP} copyValue={data.krsValue}>
					<CommonButton>{krsRedButtonText}</CommonButton>
				</CopyToolTip>
			</CopyWrapper>
		</Wrapper>
	)
}

export default BannerKRS
